import axios from 'axios';

const API_ENDPOINT = import.meta.env.VITE_API_URL || 'http://propidasystemv1-env.gkm4nsu2am.eu-north-1.elasticbeanstalk.com';

export default axios.create({
  baseURL: API_ENDPOINT,
});
